import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Col, Row } from 'react-bootstrap';
import TextLoading from '@/app/common/components/skeleton/TextLoading';
import FalconCardHeader from '@/components/common/FalconCardHeader';

type BlockProps = {
  width: number | string;
  height: number;
  className?: string;
};

const Block = ({ width, height, className = '' }: BlockProps) => (
  <span className={`d-block ${className}`.trim()}>
    <TextLoading
      width={width}
      height={height}
      isWidthPx={typeof width === 'number'}
    />
  </span>
);

const ChartPreload = ({
  title,
  legendCount
}: {
  title: string;
  legendCount: number;
}) => {
  const barHeights = [112, 166, 134, 198, 148, 178, 126];

  return (
    <Card className="h-100" aria-busy="true">
      <FalconCardHeader
        title={title}
        titleTag="h6"
        className="py-2"
        light
        endEl={
          <span className="text-600 opacity-50" aria-hidden="true">
            <FontAwesomeIcon icon="ellipsis-h" className="fs--2" />
          </span>
        }
      />
      <Card.Body className="py-3">
        <div
          className="d-flex align-items-end gap-2 justify-content-center px-2"
          style={{ height: 250 }}
          aria-hidden="true"
        >
          {barHeights.map((height, index) => (
            <span
              key={index}
              className="d-block flex-shrink-0"
              style={{ width: 22, height }}
            >
              <TextLoading width={22} height={height} isWidthPx />
            </span>
          ))}
        </div>
      </Card.Body>
      <div className="d-flex mt-2 mb-3 gap-2 justify-content-center align-items-center">
        {Array.from({ length: legendCount }, (_, index) => (
          <div key={index} className="d-flex align-items-center gap-1">
            <Block width={8} height={8} className="rounded-circle" />
            <Block width={index % 2 === 0 ? 46 : 58} height={10} />
          </div>
        ))}
      </div>
    </Card>
  );
};

const CrawlFormPreload = () => (
  <div className="mt-3 mb-4" aria-hidden="true">
    <Row>
      <Col md={8}>
        <div className="d-flex gap-2 position-relative flex-lg-row flex-column align-items-center">
          <div className="input-group input-group-md flex-grow-1 w-100">
            <Block width="100%" height={38} />
          </div>
          <Block width={120} height={38} className="w-100 w-lg-auto" />
        </div>
      </Col>
    </Row>
  </div>
);

const HistoryTablePreload = () => {
  const columnWidths = ['30%', '13%', '10%', '10%', '12%', '11%', '10%', '6%'];

  return (
    <div
      className="ag-theme-custom border rounded-1 overflow-hidden"
      style={{ height: 460 }}
      aria-hidden="true"
    >
      <div className="d-flex align-items-center gap-3 bg-body-tertiary border-bottom px-2 py-3">
        {columnWidths.map((width, index) => (
          <span
            key={index}
            className="d-block"
            style={{ flex: `1 1 ${width}`, minWidth: 0 }}
          >
            <Block width="100%" height={12} />
          </span>
        ))}
      </div>
      {Array.from({ length: 8 }, (_, row) => (
        <div
          key={row}
          className="d-flex align-items-center gap-3 border-bottom px-2"
          style={{ height: 51 }}
        >
          {columnWidths.map((width, column) => (
            <span
              key={column}
              className="d-block"
              style={{ flex: `1 1 ${width}`, minWidth: 0 }}
            >
              <Block
                width={row % 2 === 0 ? '100%' : '86%'}
                height={11}
              />
            </span>
          ))}
        </div>
      ))}
    </div>
  );
};

const HistoryPreload = () => (
  <div aria-busy="true" aria-label="درحال بارگذاری">
    <CrawlFormPreload />

    <Row className="g-3 mb-3">
      <Col md={6} xl={4}>
        <ChartPreload title="سلامت سایت" legendCount={1} />
      </Col>
      <Col md={6} xl={4}>
        <ChartPreload title="صفحات خزش شده" legendCount={2} />
      </Col>
      <Col md={6} xl={4}>
        <ChartPreload title="فهرست وضعیت" legendCount={3} />
      </Col>
    </Row>

    <HistoryTablePreload />
  </div>
);

export default HistoryPreload;
